import React, { useState, useEffect } from "react";
import "./MachineryTechnology.css";

import machine1 from "../images/machine.jpg";
import machine2 from "../images/machine2.png";
import machine3 from "../images/machine3.png";
import machine4 from "../images/machine4.png";
import machine5 from "../images/m1.jpeg";
import machine6 from "../images/m2.jpeg";
import machine7 from "../images/m3.jpeg";
import machine8 from "../images/m4.jpeg";
import machine9 from "../images/m5.jpeg";
import machine10 from "../images/m6.jpeg";  
import machine11 from "../images/m7.jpeg";
import machine12 from "../images/m8.jpeg";
import machine13 from "../images/m9.jpeg";
import machine14 from "../images/m10.jpeg";
import machine15 from "../images/m11.jpeg";
import machine16 from "../images/m12.jpeg";
import machine17 from "../images/m13.jpeg";

const machineryPoints = [
  "Production facility with high level of mechanization geared towards solid and panel woodworking.",
  "It is adept to function independently and is completely self-contained.",
  "Over 80% of our machinery is imported with leading brands from around the world."
];

const machineryImages = [
  machine1,
  machine2,
  machine3,
  machine4,
  machine3,
  machine5,
  machine6,
  machine7,
  machine8,
  machine9,
  machine10,
  machine11,
  machine12,
  machine13,
  machine14,
  machine15,
  machine16,
  machine17
];

const MachineryTechnology = () => {
  const [currentImage, setCurrentImage] = useState(0);

  const nextSlide = () => {
    setCurrentImage((prev) =>
      prev === machineryImages.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentImage((prev) =>
      prev === 0 ? machineryImages.length - 1 : prev - 1
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 3000);

    return () => clearInterval(interval);
  }, [currentImage]);

  return (
    <section className="machinery-section"  id="machinery">
      <div className="machinery-container">

        {/* Left Side */}
        <div className="machinery-content">
          <div className="title-wrapper">
            <h2>
              Infrastructure &
              <br />
              TECHNOLOGY
            </h2>
          </div>

          <ul className="machinery-list">
            {machineryPoints.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>

          <div className="brands-content">
            <p>
              Homag, Bacci, Biesse, Weinig, Buetferring,
              Altendorf, Balestrini, Holytek, Torreda,
              controlling 4 side planning, wide belt sanding,
              panel sawing, tenoning/mortising, laser guided
              ripping, veneer machinery, segmented pad sander
              and 1500 sq. ft. clean room.
            </p>

            <p>
              Along with various other state-of-the-art
              machining centers ensuring exceptional quality
              and precision in every product.
            </p>
          </div>
        </div>

        {/* Right Side */}
        <div className="machinery-image-wrapper">

          <img
            src={machineryImages[currentImage]}
            alt="Machinery"
            className="machinery-slider-image"
          />

          {/* Previous Button */}
          <button
            className="slider-btn prev-btn"
            onClick={prevSlide}
          >
            ❮
          </button>

          {/* Next Button */}
          <button
            className="slider-btn next-btn"
            onClick={nextSlide}
          >
            ❯
          </button>

          {/* Dots */}
          <div className="slider-dots">
            {machineryImages.map((_, index) => (
              <span
                key={index}
                className={`dot ${
                  currentImage === index ? "active" : ""
                }`}
                onClick={() => setCurrentImage(index)}
              />
            ))}
          </div>

        </div>

      </div>
    </section>
  );
};

export default MachineryTechnology;